import { FieldRow } from "./styles";
import {
  formatChildrenCountLabel,
  getVisitPropertyFamily,
} from "../../utils/visitDetailsProperty";

type Props = {
  property: unknown;
};

export default function PropertyFamilyFields({ property }: Props) {
  const family = getVisitPropertyFamily(property);
  if (!family.parentLabel && family.childrenCount < 1) return null;

  return (
    <>
      {family.parentLabel ? (
        <FieldRow>
          <b>Anúncio pai: </b> {family.parentLabel}
        </FieldRow>
      ) : null}
      {family.childrenCount > 0 ? (
        <>
          <FieldRow>
            <b>Unidades filhas: </b>{" "}
            {formatChildrenCountLabel(family.childrenCount)}
          </FieldRow>
          {family.children.map((child, index) => (
            <FieldRow key={child.id ?? `${child.label}-${index}`}>
              {child.label}
            </FieldRow>
          ))}
        </>
      ) : null}
    </>
  );
}
